<template>
  <!-- HEADER -->
  <div class="header">
    <div class="container-fluid">
      <!-- Body -->
      <div class="card mt-5">
        <div class="card-header">
          <!-- Title -->
          <h4 class="card-header-title">IDP Data - Experiential Learning</h4>
          <!-- Button -->
          <b-button variant="primary" @click="addProject" v-if="listTabMenu?.privilages?.create">
            <span class="fe fe-file-plus"></span>
            Add Project
          </b-button>
        </div>
        <vue-good-table
          :line-numbers="true"
          :columns="columns"
          :rows="projectData"
          :sort-options="{
            enabled: false
          }"
          :total-rows="competencyData.totalItems"
          :pagination-options="{
            enabled: true,
            mode: 'pages',
            position: 'bottom',
            perPage: 10,
            perPageDropdown: [10, 50, 100],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page',
            allLabel: 'All'
          }"
          style-class="vgt-table border-0 table"
          @on-page-change="onPageChange"
          @on-per-page-change="onPageChange">
          <!-- Loading -->
          <div slot="emptystate" class="text-center font-size-14">
            No data available
          </div>

          <!-- Custom Rows -->
          <template slot="table-row" slot-scope="props">
            <!-- Table Action -->
            <span v-if="props.column.field == 'action'">
              <b-button
                v-if="listTabMenu.privilages.update"
                class="no-wrap btn-pill"
                variant="warning"
                size="sm"
                @click="updateData(props.row)">
                <span class="fe fe-edit"></span>
              </b-button>
            </span>
          </template>
        </vue-good-table>
      </div>

      <!-- Modal -->
      <b-modal
        v-model="isCreateModal"
        centered
        hide-footer
        title="Add Project"
        size="lg">
        <form @submit.prevent="saveAdd()">
          <div class="form-group">
            <div class="row">
              <div class="col-12 mt-3">
                <label>Name</label>
                <input
                  v-validate="'required'"
                  name="Name"
                  type="text"
                  v-model="bodyAdd.name"
                  class="form-control"
                  placeholder="Name" />
              </div>
              <div class="col-12 mt-3">
                <label>Description</label>
                <textarea
                  type="text"
                  v-model="bodyAdd.description"
                  class="form-control"
                  placeholder="Description" />
              </div>
              <div class="col-12 mt-3">
                <label>Experiential Type</label>
                <v-select
                  v-model="bodyAdd.experientialType"
                  :options="experientialType"
                  label="name"
                  :reduce="(e) => e.id"
                  placeholder="Select Experiential Type" />
              </div>
              <div class="col-6 mt-3">
                <p>Start Date</p>
                <v-date-picker
                  style="width: 350px"
                  v-model="bodyAdd.startDate"
                  type="date"
                  format="DD-MM-YYYY"
                  placeholder="Select Date" />
              </div>
              <div class="col-6 mt-3">
                <p>End Date</p>
                <v-date-picker
                  style="width: 350px"
                  v-model="bodyAdd.endDate"
                  type="date"
                  format="DD-MM-YYYY"
                  placeholder="Select Date" />
              </div>
              <div class="mt-4">
                <b-button @click="showRoleModal" variant="primary"
                  ><span class="fe fe-plus"></span>Add Role</b-button
                >
              </div>

              <!-- Schedule Table -->
              <div class="mt-4 col-12">
                <label>Role</label>
                <table class="table table-sm table-bordered">
                  <thead>
                    <tr>
                      <th>Position</th>
                      <th>Total</th>
                      <th style="width: 50px">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="roleList.length === 0">
                      <td class="text-center" colspan="4">No Data Available</td>
                    </tr>
                    <tr v-else v-for="(item, index) in roleList" :key="index">
                      <td>{{ item.position }}</td>
                      <td>{{ item.total }}</td>
                      <td>
                        <button
                          @click="removeRole(index)"
                          class="btn btn-sm btn-danger">
                          <span class="fe fe-trash"></span>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-12 mt-3">
                <label>Related Competency</label>
                <v-select
                  multiple
                  v-model="bodyAdd.competency"
                  :options="competencyData"
                  label="name"
                  :reduce="(e) => e.id"
                  placeholder="Select Related Competency" />
              </div>
              <b-modal
                v-model="isRoleModalVisible"
                title="Add Role"
                size="lg"
                hide-footer
                @hide="clearRoleModal">
                <div class="form-group">
                  <div class="row">
                    <div class="col-6">
                      <label class="form-label">Position</label>
                      <v-select
                        v-model="role.position"
                        :options="projectRole"
                        label="name"
                        :reduce="(e) => e.id"
                        placeholder="Select Role" />
                    </div>
                    <div class="col-6">
                      <label class="form-label">Total</label>
                      <input
                        v-validate="'required'"
                        name="Total"
                        type="number"
                        v-model="role.total"
                        class="form-control"
                        placeholder="Total" />
                    </div>
                  </div>
                  <div class="mt-4">
                    <b-button
                      class="float-end"
                      @click="addRole"
                      variant="primary"
                      >Add</b-button
                    >
                  </div>
                </div>
              </b-modal>
            </div>
          </div>
          <div class="form-group">
            <button
              style="margin-left: auto; float: right"
              class="mt-4 btn btn-primary"
              type="submit"
              v-if="isLoading == false">
              Save
            </button>
            <button
              style="margin-left: auto; float: right"
              class="mt-4 btn btn-primary"
              type="button"
              disabled
              v-else>
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"></span>
              Loading...
            </button>
          </div>
        </form>
      </b-modal>
    </div>
  </div>
</template>
<script>
export default {
  name: "experientialData",
  computed: {},
  data() {
    return {
      isCreateModal: false,
      isRoleModalVisible: false,
      competencyData: [],
      experientialType: [],
      projectRole: [],
      projectData: [],
      roleList: [],
      listTabMenu: {},
      role: {
        position: "",
        total: ""
      },
      body: {
        page: 1,
        limit: 10
        // order: "",
        // search: "",
      },
      bodyAdd: {
        experientialId: "",
        name: "",
        description: "",
        experientialType: "",
        role: "",
        startDate: "",
        endDate: "",
        duration: "",
        competency: ""
      },
      bodyUpdate: {
        id: "",
        roles_name: "",
        description: ""
      },
      isAdd: true,
      isLoading: false,
      columns: [
        {
          label: "Name",
          field: "name",
          thClass: "table-header text-muted w-50 font-weight-bold",
          tdClass: "color-secondary align-middle"
        },
        {
          label: "Description",
          field: "description",
          thClass: "table-header text-muted w-25 font-weight-bold text-center ",
          tdClass: "color-secondary align-middle text-center"
        },
        // {
        //   label: "Experiential Type",
        //   field: "experiential_type",
        //   thClass: "table-header text-muted w-25 font-weight-bold text-center ",
        //   tdClass: "color-secondary align-middle text-center"
        // },
        {
          label: "Start Date",
          field: "start_date",
          thClass:
            "table-header no-wrap text-muted w-25 font-weight-bold text-center",
          tdClass: "no-wrap color-secondary align-middle text-center"
        },
        {
          label: "End Date",
          field: "end_date",
          thClass:
            "table-header no-wrap text-muted w-25 font-weight-bold text-center",
          tdClass: "no-wrap color-secondary align-middle text-center"
        }
        // {
        //   label: "ACTION",
        //   field: "action",
        //   thClass: "table-header no-wrap text-muted font-weight-bold",
        //   tdClass: "no-wrap color-secondary align-middle"
        // }
      ]
    };
  },
  mounted() {
    this.getCompetency();
    this.getExperientialType();
    this.getRole();
    this.getProject();
    const listMenu = JSON.parse(localStorage.getItem('listMenu') || [])
    const currentPath = window.location.pathname; // Path dari URL saat ini
    const menu = listMenu.find((menu) =>
      menu.link === String(currentPath) || menu.children.some((child) => child.link === String(currentPath))
    );
    this.listTabMenu = menu;
  },
  watch: {
    "bodyAdd.startDate": "calculateDuration",
    "bodyAdd.endDate": "calculateDuration"
  },
  methods: {
    clearProjectModal() {
      this.bodyAdd.name = "";
      this.bodyAdd.description = "";
      this.bodyAdd.experientialType = "";
      this.bodyAdd.startDate = "";
      this.bodyAdd.endDate = "";
      this.bodyAdd.role = "";
      this.roleList = []
      this.bodyAdd.competency = "";
    },
    addProject() {
      this.isCreateModal = true;
    },
    calculateDuration() {
      if (this.bodyAdd.startDate && this.bodyAdd.endDate) {
        const startDate = new Date(this.bodyAdd.startDate);
        const endDate = new Date(this.bodyAdd.endDate);

        // Cek jika startDate dan endDate sama
        if (startDate.getTime() === endDate.getTime()) {
          this.bodyAdd.duration = 1; // Set duration ke 1 jika tanggal sama
        } else {
          const diffTime = Math.abs(endDate - startDate);
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // Convert milliseconds to days
          this.bodyAdd.duration = diffDays; // Set the duration
        }
      } else {
        this.bodyAdd.duration = ""; // Clear duration if dates are not valid
      }
    },
    findRoleDetails(positionId) {
      const role = this.projectRole.find((role) => role.id === positionId);
      return role ? { name: role.name, id: role.id } : { name: "", id: null };
    },
    addRole() {
      const roleDetails = this.findRoleDetails(this.role.position);
      const body = {
        position: roleDetails.name, 
        total: this.role.total,
        positionId: roleDetails.id 
      };
      // console.log("isibodiaddrole", body);
      this.roleList.push(body);
      this.clearRoleModal();
      this.isRoleModalVisible = false;
    },
    removeRole(index) {
      this.roleList.splice(index, 1);
    },
    showRoleModal() {
      this.isRoleModalVisible = true;
    },
    clearRoleModal() {
      this.role = { position: "", total: "" };
    },
    updateData(props) {
      this.$bvModal.show("modal-1");
      this.isAdd = false;
      this.bodyUpdate.id = props.id;
      this.bodyUpdate.roles_name = props.roles_name;
      this.bodyUpdate.description = props.description;
    },
    formatDate(date) {
      return this.$moment(date).format("YYYY-MM-DD");
    },
    saveAdd() {
      const roles = this.roleList.map((role) => ({
        role_id: role.positionId,
        quantity: role.total
      }));

      let bodyAdd = {
        name: this.bodyAdd.name,
        description: this.bodyAdd.description,
        project_type_id: this.bodyAdd.experientialType,
        start_date: this.formatDate(this.bodyAdd.startDate),
        end_date: this.formatDate(this.bodyAdd.endDate),
        // roles: this.bodyAdd.role,
        roles: roles,
        competency: this.bodyAdd.competency
      };
      console.log("body add", bodyAdd);
      this.$store
        .dispatch("myIdp/createProject", bodyAdd)
        .then((response) => {
          this.$swal("Success", "Proyek berhasil dibuat", "success");
          this.isCreateModal = false;
          this.clearProjectModal();
          this.getProject();
        })
        .catch((error) => {
          this.$swal(
            "Error",
            "Proyek belum berhasil dibuat: " +
              (error.response?.data?.message || error.message),
            "error"
          );
        });
    },

    saveUpdate() {
      this.isLoading = true;
      this.$store
        .dispatch("role/updateRole", this.bodyUpdate)
        .then((resp) => {
          this.$swal({
            title: "Tersimpan",
            text: "Data berhasil disimpan",
            icon: "success",
            confirmButtonText: "OK"
          }).then((resp) => {
            this.isLoading = false;
            this.getCompetency();
            this.$bvModal.hide("modal-1");
          });
        })
        .catch((resp) => {
          this.$swal("Error", "Gagal menambah data", "error");
        });
    },
    deleteData(id) {
      this.$swal({
        title: "Apakah Anda yakin?",
        text: "Tindakan ini tidak dapat dibatalkan!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Ya, hapus",
        cancelButtonText: "Batal"
      }).then((result) => {
        if (result.isConfirmed) {
          this.isLoading = true;
          this.$store
            .dispatch("role/delRole", id)
            .then((resp) => {
              this.isLoading = false;
              this.getCompetency();
              this.$swal("Terhapus", "Data berhasil dihapus", "success");
            })
            .catch((resp) => {
              this.$swal("Error", "Gagal menghapus data", "error");
            });
        }
      });
    },

    // api hit
    getCompetency() {
      this.$store.dispatch("competency/getDataCompetency").then((res) => {
        this.competencyData = res.data;
      });
    },
    getExperientialType() {
      this.$store.dispatch("projectType/getProjectType").then((res) => {
        this.experientialType = res.data;
      });
    },
    getRole() {
      this.$store.dispatch("projectRole/getProjectRole").then((res) => {
        this.projectRole = res.data;
      });
    },
    getProject() {
      this.$store.dispatch("project/getProject").then((res) => {
        this.projectData = res.data;
      });
    },

    // filter
    // filterPage() {
    //   this.getCompetency();
    // },

    sorting() {
      // this.onPageChange((payload) => {
      //   // payload.currentPerPage=  10,
      //   // payload.currentPage= 1
      // })

      this.getCompetency();
      this.body.page = 1;
    },

    // Pagination
    onPageChange(payload) {
      this.body.limit = payload.currentPerPage;
      this.body.page = payload.currentPage;
      this.getCompetency();
      // if (
      //   parseInt(payload.currentPage) * parseInt(payload.currentPerPage) >
      //   1000
      // ) {
      // }
    }
  }
};
</script>
